"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const AWS = tslib_1.__importStar(require("aws-sdk"));
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const knowledge_central_entity_1 = require("../../../../service-lib/src/lib/entities/knowledge-central.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
let KnowledgeRepository = class KnowledgeRepository {
    constructor(kcRepo) {
        this.kcRepo = kcRepo;
        this.bucket = process.env.S3_AWS_BUCKET || '';
        this.region = process.env.S3_AWS_REGION || '';
        this.docRepoPath = process.env.DOCUMENT_REPOSITORY || 'tmp/document-repository';
        this.repoMode = process.env.DOCUMENT_REPOSITORY_MODE || 'LFS';
        this.initialized = false;
        if (this.repoMode === 'AWS') {
            try {
                AWS.config.update({
                    // accessKeyId: process.env.S3_AWS_ACCESS_KEY_ID,
                    // secretAccessKey: process.env.S3_AWS_SECRET_ACCESS_KEY,
                    region: process.env.S3_AWS_REGION,
                });
                this.s3 = new AWS.S3();
                this.initialized = true;
            }
            catch (err) {
                console.error('AWS initialization failed:', err);
                this.initialized = false;
            }
        }
        else {
            const fs = require('fs');
            try {
                if (fs.existsSync(this.docRepoPath) && fs.statSync(this.docRepoPath).isDirectory()) {
                    this.initialized = true;
                }
                else {
                    console.error(`Local repository path invalid: ${this.docRepoPath}`);
                    this.initialized = false;
                }
            }
            catch (err) {
                console.error('Local repository check failed:', err);
                this.initialized = false;
            }
        }
    }
    async getStatusId(key) {
        const status = await this.kcRepo.manager.findOne(look_up_entity_1.LookUp, {
            where: { lookUpKey: key },
        });
        if (!status) {
            throw new Error(`Status lookup not found for key ${key}`);
        }
        return status.id;
    }
    async createFileEntry(file, data) {
        if (!this.initialized) {
            throw new Error('Document repository is not initialized. Cannot create file entry.');
        }
        console.log('Document repository initialized successfully.');
        const fileName = `${Date.now()}_${file.originalname}`;
        const key = `uploads/knowledge-central/${data.categoryId}/${fileName}`;
        let relativePath = key;
        try {
            if (this.repoMode === 'AWS') {
                const uploadResult = await this.s3
                    .putObject({ Bucket: this.bucket, Key: key, Body: file.buffer })
                    .promise();
                if (!uploadResult || uploadResult.$response.error) {
                    throw new Error('File upload to S3 failed.');
                }
            }
            else {
                const fs = require('fs');
                const path = require('path');
                const fullDirPath = path.join(this.docRepoPath, relativePath);
                const fullFilePath = path.join(fullDirPath, fileName);
                console.log('Full directory path:', fullDirPath);
                console.log('Full file path:', fullFilePath);
                // Ensure directory exists
                try {
                    fs.mkdirSync(fullDirPath, { recursive: true });
                    console.log('Directory created:', fullDirPath);
                }
                catch (mkdirErr) {
                    console.error('Failed to create directory:', mkdirErr);
                }
                // Write file
                try {
                    fs.writeFileSync(fullFilePath, file.buffer);
                    console.log('File written successfully:', fullFilePath);
                }
                catch (writeErr) {
                    console.error('Failed to write file:', writeErr);
                }
            }
            const newDocumentId = Date.now();
            const statusId = await this.getStatusId(constants_1.KNOWLEDGE_STATUS_ACTIVE);
            const entity = this.kcRepo.create({
                title: data.title,
                docTypeId: data.docTypeId,
                statusId,
                categoryId: data.categoryId,
                fileName: file.originalname,
                relativePath,
                extension: file.originalname.split('.').pop(),
                summary: data.summary,
                tags: Array.isArray(data.tags)
                    ? data.tags
                    : data.tags
                        ? [data.tags]
                        : [],
                accessCount: 0,
                version: 1,
                createdBy: data.createdBy,
                updatedBy: data.updatedBy,
                documentId: newDocumentId,
                createdAt: new Date(),
                updatedAt: new Date(),
                deletedAt: null,
            });
            try {
                await this.kcRepo.save(entity);
                return {
                    message: 'File uploaded successfully',
                };
            }
            catch (saveErr) {
                console.error('Failed to save knowledge central entity:', saveErr);
                throw new Error('Could not save file metadata to the database.');
            }
        }
        catch (err) {
            console.error('Error in createFileEntry:', err);
            throw new Error(`File upload failed: ${err.message || err}`);
        }
    }
    async createUrlEntry(data) {
        const statusId = await this.getStatusId(constants_1.KNOWLEDGE_STATUS_ACTIVE);
        if (data.tags) {
            data.tags = Array.isArray(data.tags)
                ? data.tags
                : data.tags
                    ? [data.tags]
                    : [];
        }
        const entity = this.kcRepo.create({
            ...data,
            fileName: data.title,
            statusId,
            relativePath: data.relativePath,
            documentId: Date.now(),
            version: 1,
            accessCount: 0,
        });
        return this.kcRepo.save(entity);
    }
    async replaceFile(documentId, file, updatedBy, data = {}) {
        try {
            const activeStatusId = await this.getStatusId(constants_1.KNOWLEDGE_STATUS_ACTIVE);
            const deletedStatusId = await this.getStatusId(constants_1.KNOWLEDGE_STATUS_DELETED);
            const existing = await this.kcRepo.findOne({
                where: { documentId: documentId, statusId: activeStatusId },
                order: { version: 'DESC' },
                relations: ['category'],
            });
            if (!existing) {
                throw new Error('Document not found');
            }
            const fileName = `${Date.now()}_${file.originalname}`;
            const category = data.categoryId ?? existing.categoryId;
            const key = `uploads/knowledge-central/${category}/${fileName}`;
            let relativePath = key;
            // Upload the new file to S3 or local file system
            if (this.repoMode === 'AWS') {
                await this.s3
                    .putObject({ Bucket: this.bucket, Key: key, Body: file.buffer })
                    .promise();
            }
            else {
                const fs = require('fs');
                const path = require('path');
                const fullDirPath = path.join(this.docRepoPath, key.split('/').slice(0, -1).join('/'));
                const fullFilePath = path.join(fullDirPath, fileName);
                // Ensure directory exists
                try {
                    fs.mkdirSync(fullDirPath, { recursive: true });
                    console.log('Directory created:', fullDirPath);
                }
                catch (mkdirErr) {
                    console.error('Failed to create directory:', mkdirErr);
                }
                // Write file
                try {
                    fs.writeFileSync(fullFilePath, file.buffer);
                    console.log('File written successfully:', fullFilePath);
                }
                catch (writeErr) {
                    console.error('Failed to write file:', writeErr);
                }
            }
            // Mark existing document as deleted
            await this.kcRepo.save({
                ...existing,
                statusId: deletedStatusId,
                deletedAt: new Date(),
                updatedBy,
            });
            if (data.tags) {
                data.tags = Array.isArray(data.tags)
                    ? data.tags
                    : data.tags
                        ? [data.tags]
                        : [];
            }
            // Create a new entry with updated details
            const newEntry = this.kcRepo.create({
                ...existing,
                ...data,
                id: undefined,
                relativePath,
                fileName: file.originalname,
                extension: file.originalname.split('.').pop(),
                version: (existing.version || 1) + 1,
                statusId: activeStatusId,
                deletedAt: null,
                documentId: documentId,
                createdBy: updatedBy,
                updatedBy,
            });
            await this.kcRepo.save(newEntry);
            return { message: 'File replaced successfully.' };
        }
        catch (err) {
            console.error('Error in replaceFile:', err);
            throw new Error(`File replacement failed: ${err.message || err}`);
        }
    }
    async replaceUrl(documentId, url, updatedBy, data = {}) {
        const activeStatusId = await this.getStatusId(constants_1.KNOWLEDGE_STATUS_ACTIVE);
        const deletedStatusId = await this.getStatusId(constants_1.KNOWLEDGE_STATUS_DELETED);
        const existing = await this.kcRepo.findOne({
            where: { documentId, statusId: activeStatusId },
            order: { version: 'DESC' },
        });
        if (!existing)
            return { message: "Unable to find the requested resource" };
        await this.kcRepo.save({
            ...existing,
            statusId: deletedStatusId,
            deletedAt: new Date(),
            updatedBy,
        });
        const newEntry = this.kcRepo.create({
            ...existing,
            ...data,
            id: undefined,
            fileName: existing.fileName,
            relativePath: url,
            version: (existing.version || 1) + 1,
            statusId: activeStatusId,
            deletedAt: null,
            documentId: existing.documentId,
            createdBy: updatedBy,
            updatedBy,
        });
        return this.kcRepo.save(newEntry);
    }
    async updateMetadata(documentId, data, updatedBy) {
        try {
            if (documentId !== data.documentId) {
                throw new Error('Document ID mismatch');
            }
            const existing = await this.kcRepo.findOne({
                where: { documentId, status: { lookUpKey: constants_1.KNOWLEDGE_STATUS_ACTIVE } },
                order: { version: 'DESC' },
            });
            if (!existing) {
                return {
                    message: "Unable to find the requested resource"
                };
            }
            existing.tags = Array.isArray(data.tags)
                ? data.tags
                : data.tags
                    ? [data.tags]
                    : [];
            const savedData = await this.kcRepo.save({ ...existing, ...data, updatedBy });
            return {
                data: savedData,
                message: "File updated successfully"
            };
        }
        catch (err) {
            console.error('Error in updateMetadata:', err);
            throw new Error(`Failed to update metadata: ${err.message || err}`);
        }
    }
    async softDelete(documentId, updatedBy) {
        try {
            const deletedStatusId = await this.getStatusId(constants_1.KNOWLEDGE_STATUS_DELETED);
            const existing = await this.kcRepo.findOne({
                where: { documentId, status: { lookUpKey: constants_1.KNOWLEDGE_STATUS_ACTIVE } }
            });
            if (!existing) {
                return {
                    message: "Unable to find the requested resource"
                };
            }
            await this.kcRepo.save({
                ...existing,
                statusId: deletedStatusId,
                deletedAt: new Date(),
                updatedBy,
            });
            return {
                message: 'Document deleted successfully',
            };
        }
        catch (err) {
            console.error('Error in softDelete:', err);
            throw new Error(`Failed to delete document: ${err.message || err}`);
        }
    }
    async list(categoryId, page = 1, limit = 10) {
        const where = {
            status: { lookUpKey: constants_1.KNOWLEDGE_STATUS_ACTIVE }
        };
        if (categoryId)
            where.categoryId = categoryId;
        return this.kcRepo.find({
            where,
            order: { createdAt: 'DESC' },
            skip: (page - 1) * limit,
            take: limit,
        });
    }
    async listForAllCategories(start = 0, limit = 10) {
        const categories = await this.kcRepo.manager.find(look_up_entity_1.LookUp, {
            where: { lookUpName: 'KNOWLEDGE_CATEGORY' },
            order: { lookUpOrder: 'ASC' },
        });
        const docTypes = await this.kcRepo.manager.find(look_up_entity_1.LookUp, {
            where: { lookUpName: "KNOWLEDGE_DOC_TYPE" },
            order: { lookUpOrder: "ASC" }
        });
        const query = `
    WITH categories AS (
      SELECT
        category_id,
        COUNT(*) AS category_count
      FROM knowledge_central
      GROUP BY category_id
    )
    SELECT
      kc.id,
      kc.document_id,
      kc.version,
      kc.title,
      kc.doc_type_id,
      kc.status_id,
      kc.category_id,
      kc.relative_path,
      kc.extension,
      kc.summary,
      kc.tags,
      kc.access_count,
      kc.created_at,
      kc.deleted_at,
      kc.created_by,
      c.category_count
    FROM categories AS c
    CROSS JOIN LATERAL (
      SELECT
        kc.id,
        document_id,
        version,
        title,
        doc_type_id,
        status_id,
        category_id,
        relative_path,
        extension,
        summary,
        tags,
        access_count,
        kc.created_at,
        kc.deleted_at,
        kc.created_by
      FROM knowledge_central AS kc, lookup_data AS ld
      WHERE kc.category_id = c.category_id AND kc.status_id = ld.id
        AND ld.lookup_key = '${constants_1.KNOWLEDGE_STATUS_ACTIVE}'
      ORDER BY kc.created_at DESC
      LIMIT ${limit} OFFSET ${start}
    ) AS kc
    ORDER BY
      c.category_id,
      kc.created_at DESC;
    `;
        const rawQueryResults = await this.kcRepo.query(query);
        const data = {};
        const categoryTotalCounts = new Map();
        // Initialize data object with all categories from the LookUp table
        // This ensures that all categories are present in the response, even if empty.
        for (const category of categories) { // `categories` is LookUp[]
            data[category.id.toString()] = [];
            categoryTotalCounts.set(category.id, 0);
        }
        // Populate the data object from the raw query results
        for (const row of rawQueryResults) {
            // Map snake_case columns from SQL to camelCase properties of KnowledgeCentral
            const knowledgeEntry = {
                id: row.id,
                documentId: row.document_id,
                version: row.version,
                title: row.title,
                docTypeId: row.doc_type_id,
                statusId: row.status_id,
                categoryId: row.category_id,
                relativePath: row.relative_path,
                extension: row.extension,
                summary: row.summary,
                tags: row.tags,
                accessCount: row.access_count,
                createdAt: new Date(row.created_at), // Ensure Date type
                deletedAt: row.deleted_at ? new Date(row.deleted_at) : null,
                createdBy: row.created_by, // Assuming created_by in DB is a user ID (number)
                // Note: `updatedAt` and `updatedBy` are not selected in the raw query,
                // so they will be undefined in these mapped objects if not added to the SQL SELECT.
            }; // Cast to KnowledgeCentral type
            categoryTotalCounts.set(row.category_id, row.category_count);
            const categoryIdStr = row.category_id.toString();
            // The categoryIdStr should already exist as a key due to the initialization loop above.
            // Add the entry to the corresponding category list.
            if (data[categoryIdStr]) {
                data[categoryIdStr].push(knowledgeEntry);
            }
        }
        const augmentedCategories = categories.map(category => ({
            ...category,
            documentCount: categoryTotalCounts.get(category.id),
        }));
        const mostPopular = await this.kcRepo.find({
            where: { status: { lookUpKey: constants_1.KNOWLEDGE_STATUS_ACTIVE } },
            order: { accessCount: "DESC" },
            skip: start,
            take: limit
        });
        const recentlyAdded = await this.kcRepo.find({
            where: { status: { lookUpKey: constants_1.KNOWLEDGE_STATUS_ACTIVE } },
            order: { createdAt: "DESC" },
            skip: start,
            take: limit
        });
        return { categories: augmentedCategories, docTypes, data, mostPopular, recentlyAdded };
    }
    async incrementAccessCount(documentId) {
        try {
            const statusId = await this.getStatusId(constants_1.KNOWLEDGE_STATUS_ACTIVE);
            await this.kcRepo.increment({ documentId: documentId, statusId: statusId }, "accessCount", 1);
            return {
                message: 'Access count incremented successfully',
            };
        }
        catch (err) {
            console.error('Error incrementing access count:', err);
            throw new Error(`Failed to increment access count: ${err.message || err}`);
        }
    }
    async findActiveDocument(documentId) {
        return await this.kcRepo.findOne({
            where: { documentId, status: { lookUpKey: constants_1.KNOWLEDGE_STATUS_ACTIVE } },
            order: { version: "DESC" },
        });
    }
    async getFileStream(key) {
        // Validation for required field
        if (!key || typeof key !== 'string' || !key.trim()) {
            throw new Error('File key is required.');
        }
        if (this.repoMode === 'AWS') {
            // Fetch the file and its metadata from S3
            const params = { Bucket: this.bucket, Key: key };
            try {
                const head = await this.s3.headObject(params).promise();
                const s3Stream = await this.s3.getObject(params).createReadStream();
                return { stream: s3Stream, mimeType: head.ContentType, contentLength: head.ContentLength };
            }
            catch (err) {
                console.error("S3 file fetch error:", err); // log this
                throw new Error("File not found in S3.");
            }
        }
        else {
            // Read the file from the local filesystem (LFS)
            const fs = require('fs');
            const path = require('path');
            const fullFilePath = path.join(this.docRepoPath, key);
            if (!fs.existsSync(fullFilePath)) {
                throw new Error('File not found in local storage');
            }
            const localStream = fs.createReadStream(fullFilePath);
            const mime = require('mime-types');
            const mimeType = mime.lookup(fullFilePath) || 'application/octet-stream';
            const contentLength = fs.statSync(fullFilePath).size;
            return {
                stream: localStream,
                mimeType,
                contentLength,
            };
        }
    }
};
exports.KnowledgeRepository = KnowledgeRepository;
exports.KnowledgeRepository = KnowledgeRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(knowledge_central_entity_1.KnowledgeCentral)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object])
], KnowledgeRepository);
